import { render } from "./SubmissionView.vue?vue&type=template&id=05d48b71&scoped=true&ts=true"
import script from "./SubmissionView.vue?vue&type=script&lang=ts"
export * from "./SubmissionView.vue?vue&type=script&lang=ts"

import "./SubmissionView.vue?vue&type=style&index=0&id=05d48b71&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05d48b71"]])

export default __exports__